<div class="page-header">

  <div id="menu-opener"><i class="material-icons">&#xE5D2;</i></div>

  <h1>{{pageName()}}</h1>

  <div id="disconnect">
    <div class="btn-group">
      <!-- Without avatar -->
      @if (!userAvatar() || userAvatar()=='null') {
        <div id="avatar-icon" class="avatar-icon"
          [ngClass]="AvatarBackground"
          (click)="toggleDropdown($event)">{{displayLogin() | trigrammePipe}}
        </div>
      }
      <!-- With avatar -->
      @if (userAvatar() && userAvatar()!='null') {
        <img id="avatar-icon" class="avatar-icon" [src]="userAvatar()" (click)="toggleDropdown($event)">
      }

      @if (showDropdown()) {
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a [routerLink]="['Settings']">Profile settings</a></li>
          <li><a [routerLink]="['ReleaseNote']">Release note</a></li>
          <li><a [routerLink]="['Tutorials']">Tutorials (draft)</a></li>
          <li class="divider"></li>
          <li><a [routerLink]="['Logout']">Sign out</a></li>
        </ul>
      }
    </div>
  </div>
</div>
